import { RouteObject } from "react-router-dom";
import { FaqsList } from "../pages/admin/faq/FaqsList";
import { FaqCreate } from "../pages/admin/faq/FaqCreate";
import { FaqEdit } from "../pages/admin/faq/FaqEdit";

export const faqRoutes: RouteObject[] = [
  {
    id: "faqs-list",
    index: true,
    element: <FaqsList />,
  },
  {
    id: "faq-edit",
    path: ":id/edit",
    element: <FaqEdit />,
  },
  {
    id: "faq-create",
    path: "create",
    element: <FaqCreate />,
  },
];
